import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-navy-900 py-8 px-4 border-t border-navy-800 text-center" data-id="element-40">
        <div className="max-w-4xl mx-auto" data-id="element-41">
          <p className="text-sm text-[#D4AF37]" data-id="element-42">
            &copy; {new Date().getFullYear()} Sistema IMÁN - Vender Sin
            Perseguir. Todos los derechos reservados.
          </p>
          <p className="text-xs mt-2 max-w-2xl mx-auto text-[#D4AF37]" data-id="element-43">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
          <div className="flex items-center justify-center gap-4 mt-4" data-id="element-44">
            <button onClick={() => setActiveModal('privacy')} className="text-xs hover:text-gold-500 transition-colors underline underline-offset-2 text-[#C9A84C]" data-id="element-45">
              Política de Privacidad
            </button>
            <span className="text-cream-100/30" data-id="element-46">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-xs hover:text-gold-500 transition-colors underline underline-offset-2 text-[#C9A84C]" data-id="element-47">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-48">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-49">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-navy-800 border border-navy-700 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-50">
              <div className="sticky top-0 bg-navy-800 border-b border-navy-700 px-6 py-4 flex items-center justify-between rounded-t-2xl z-10" data-id="element-51">
                <h2 className="text-lg font-bold text-[#D4AF37]" data-id="element-52">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-cream-100/60 hover:text-cream-50 transition-colors p-1 rounded-lg hover:bg-navy-700" data-id="element-53">
                  <XIcon className="w-5 h-5" data-id="element-54" />
                </button>
              </div>

              <div className="px-6 py-6 text-sm text-cream-100/80 leading-relaxed space-y-4" data-id="element-55">
                {activeModal === 'privacy' ? <>
                    <p className="text-xs text-[#F5F0E8]" data-id="element-56">
                      Última actualización:{' '}
                      {new Date().toLocaleDateString('es-ES', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
                    </p>
                    <h3 className="text-base font-semibold text-[#D4AF37]" data-id="element-57">
                      1. Información que Recopilamos
                    </h3>
                    <p className="text-[#F5F0E8]" data-id="element-58">
                      Recopilamos información personal que nos proporcionas
                      voluntariamente al realizar una compra o registrarte,
                      incluyendo tu nombre, dirección de correo electrónico y
                      datos de pago procesados de forma segura por terceros.
                    </p>
                    <h3 className="text-base font-semibold text-[#D4AF37]" data-id="element-59">
                      2. Uso de la Información
                    </h3>
                    <p className="text-[#F5F0E8]" data-id="element-60">
                      Utilizamos tu información para procesar tu compra,
                      enviarte el producto digital adquirido, y comunicarnos
                      contigo sobre actualizaciones relevantes del producto. No
                      compartimos tu información con terceros con fines de
                      marketing.
                    </p>
                    <h3 className="text-base font-semibold text-[#D4AF37]" data-id="element-61">
                      3. Protección de Datos
                    </h3>
                    <p className="text-[#F5F0E8]" data-id="element-62">
                      Implementamos medidas de seguridad técnicas y
                      organizativas para proteger tu información personal contra
                      acceso no autorizado, alteración o destrucción.
                    </p>
                    <h3 className="text-base font-semibold text-[#D4AF37]" data-id="element-63">
                      4. Cookies
                    </h3>
                    <p className="text-[#F5F0E8]" data-id="element-64">
                      Nuestro sitio puede utilizar cookies para mejorar tu
                      experiencia de navegación y analizar el tráfico del sitio.
                      Puedes configurar tu navegador para rechazar cookies.
                    </p>
                    <h3 className="text-base font-semibold text-[#D4AF37]" data-id="element-65">
                      5. Tus Derechos
                    </h3>
                    <p className="text-[#F5F0E8]" data-id="element-66">
                      Tienes derecho a acceder, rectificar o eliminar tu
                      información personal en cualquier momento. También puedes
                      solicitar la portabilidad de tus datos o limitar su
                      procesamiento.
                    </p>
                  </> : <>
                    <p className="text-xs text-[#F5F0E8]" data-id="element-67">
                      Última actualización:{' '}
                      {new Date().toLocaleDateString('es-ES', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
                    </p>
                    <h3 className="text-base font-semibold text-[#D4AF37]" data-id="element-68">
                      1. Aceptación de los Términos
                    </h3>
                    <p className="text-[#F5F0E8]" data-id="element-69">
                      Al acceder y utilizar este sitio web y adquirir nuestros
                      productos digitales, aceptas estar sujeto a estos términos
                      y condiciones de uso.
                    </p>
                    <h3 className="text-base font-semibold text-[#D4AF37]" data-id="element-70">
                      2. Producto Digital
                    </h3>
                    <p className="text-[#F5F0E8]" data-id="element-71">
                      El Sistema IMÁN - "Vender Sin Perseguir" es un producto
                      digital de información. Los resultados pueden variar según
                      la aplicación individual de las estrategias enseñadas. No
                      garantizamos resultados específicos de ingresos.
                    </p>
                    <h3 className="text-base font-semibold text-[#D4AF37]" data-id="element-72">
                      3. Política de Reembolso
                    </h3>
                    <p className="text-[#F5F0E8]" data-id="element-73">
                      Debido a la naturaleza digital del producto y su entrega
                      instantánea, todas las ventas son finales. No se ofrecen
                      reembolsos una vez que el producto ha sido entregado y
                      descargado.
                    </p>
                    <h3 className="text-base font-semibold text-[#D4AF37]" data-id="element-74">
                      4. Propiedad Intelectual
                    </h3>
                    <p className="text-[#F5F0E8]" data-id="element-75">
                      Todo el contenido del producto está protegido por derechos
                      de autor. No está permitida la reproducción, distribución
                      o reventa del material sin autorización expresa por
                      escrito.
                    </p>
                    <h3 className="text-base font-semibold text-[#D4AF37]" data-id="element-76">
                      5. Limitación de Responsabilidad
                    </h3>
                    <p className="text-[#F5F0E8]" data-id="element-77">
                      No nos hacemos responsables de pérdidas o daños derivados
                      del uso o la incapacidad de usar nuestro producto. El
                      contenido se proporciona con fines educativos e
                      informativos únicamente.
                    </p>
                    <h3 className="text-base font-semibold text-[#D4AF37]" data-id="element-78">
                      6. Modificaciones
                    </h3>
                    <p className="text-[#F5F0E8]" data-id="element-79">
                      Nos reservamos el derecho de modificar estos términos en
                      cualquier momento. Las modificaciones entrarán en vigor
                      inmediatamente después de su publicación en este sitio.
                    </p>
                  </>}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}